"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionPanel = exports.AccordionOption = exports.AccordionHeader = exports.AccordionButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = require("@chakra-ui/react");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AccordionOption = (0, _styledComponents.default)(_react.AccordionItem)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  background-color: ", ";\n\n  border-radius: ", ";\n  border: none;\n\n  &.active {\n    color: #40A8FF;\n    background-color: #194671;\n  }\n"])), props => props.theme.menuOption.color, props => props.theme.menuOption.backgroundColor, props => props.theme.menuOption.borderRadius);
exports.AccordionOption = AccordionOption;
var AccordionButton = (0, _styledComponents.default)(_react.AccordionButton)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n\n  &:focus {\n    box-shadow: none !important; // !important para sobreescribir el estilo default de chakra\n  }\n"])));
exports.AccordionButton = AccordionButton;

var AccordionHeader = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: .8rem;\n\n  @media (max-width: 480px) {\n    font-size: .8rem;\n  }\n"])));

exports.AccordionHeader = AccordionHeader;
var AccordionPanel = (0, _styledComponents.default)(_react.AccordionPanel)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 1rem;\n\n  color: #FFF;\n  background-color: #FFFFFF47;\n  border-radius: 0 0 10px 10px;\n"])));
exports.AccordionPanel = AccordionPanel;